// src\app\services\websocket.service.ts
import { Injectable } from '@angular/core';
import { Observable, Observer } from 'rxjs';
import { AnonymousSubject } from 'rxjs/internal/Subject';
import { Subject } from 'rxjs';
import { map } from 'rxjs/operators';

const CHAT_URL = 'ws://localhost:5000';

export interface Message {
  sender: string;
  msg: string;
}

@Injectable()
export class WebsocketService {
  private subject: AnonymousSubject<MessageEvent>;
  public messages: Subject<Message>;

  constructor() {
    this.messages = <Subject<Message>>this.connect().pipe(
      map((response: MessageEvent): Message => {
        // console.log(response.data);
        let data = JSON.parse(response.data);
        return data;
      })
    );
  }

  public connect(): AnonymousSubject<MessageEvent> {
    const url = 'wss://' + location.host + '/' + 'chat' + '?';
    if (!this.subject) {
      this.subject = this.create(url);
      console.log('Successfully connected: ' + url);
    }
    return this.subject;
  }

  getModel() {
    // If there is a get parameter called model, use that as the model name
    let model = new URLSearchParams(window.location.search).get('model');
    if (model === null) {
      return (model = 'chatgpt');
    }
  }

  private create(url: any): AnonymousSubject<MessageEvent> {
    let ws = new WebSocket(url);
    let observable = new Observable((obs: Observer<MessageEvent>) => {
      ws.onmessage = obs.next.bind(obs);
      ws.onerror = obs.error.bind(obs);
      ws.onclose = obs.complete.bind(obs);
      return ws.close.bind(ws);
    });
    let observer: any = {
      error: null,
      complete: null,
      next: (data: Message) => {
        if (ws.readyState === WebSocket.OPEN) {
          console.log('Message sent to websocket: ', data.msg);
          ws.send(JSON.stringify({ Text: data.msg }));
        }
      },
    };
    return new AnonymousSubject<MessageEvent>(observer, observable);
  }
}
